/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { ReactElement } from 'react';
import Slide, { SlideProps } from '@material-ui/core/Slide';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

const Transition = React.forwardRef<unknown, SlideProps>((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

/** ini extend disini ya nanti huehehhe */
interface LifepackDialogProps extends DialogProps {
  isWithDialogContent?: boolean;
}

const dialog: (props: LifepackDialogProps) => ReactElement = props => {
  const { children, isWithDialogContent = true, ...restOfProps } = props;
  return (
    <Dialog {...restOfProps} TransitionComponent={Transition}>
      {isWithDialogContent ? (
        <DialogContent>{children}</DialogContent>
      ) : (
        children
      )}
    </Dialog>
  );
};

export default dialog;
